// Mock Data for Nephrology (Kidney Diseases) Category

const baseProducts = [
    {
        id: "med-kin-1",
        name: "Cinacalcet 30mg",
        genericName: "Brand: Sensipar",
        indication: "Secondary Hyperparathyroidism",
        price: "$195",
        originalPrice: "$2,000",
        savings: "90%",
        description: "Cinacalcet is used to treat secondary hyperparathyroidism in patients with chronic kidney disease on dialysis. It works by decreasing the levels of parathyroid hormone (PTH), calcium, and phosphorus in the body.",
        dosage: "Typically taken once daily with food.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store below 25°C in a cool, dry place.",
        sideEffects: "Nausea, vomiting, diarrhea, dizziness, and low calcium levels.",
        category: "Mineral Modifiers"
    },
    {
        id: "med-kin-2",
        name: "Sevelamer 800mg",
        genericName: "Brand: Renvela",
        indication: "Hyperphosphatemia",
        price: "$85",
        originalPrice: "$1,200",
        savings: "92%",
        description: "Sevelamer is a phosphate binder used to control serum phosphorus levels in patients with chronic kidney disease on dialysis. It binds to phosphate in the gut to prevent its absorption.",
        dosage: "Taken with meals.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store below 25°C in a cool, dry place.",
        sideEffects: "Nausea, vomiting, stomach pain, constipation, and diarrhea.",
        category: "Phosphate Binders"
    },
    {
        id: "med-kin-3",
        name: "Darbepoetin alfa",
        genericName: "Brand: Aranesp",
        indication: "Anemia in CKD",
        price: "$245",
        originalPrice: "$3,600",
        savings: "93%",
        description: "Darbepoetin alfa is an erythropoiesis-stimulating agent (ESA) used to treat anemia associated with chronic kidney disease. It stimulates the bone marrow to produce more red blood cells.",
        dosage: "Administered as a subcutaneous or intravenous injection.",
        packaging: "Single-dose syringe or vial",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store in a refrigerator at 2°C to 8°C. Do not freeze.",
        sideEffects: "High blood pressure, fluid retention, shortness of breath, and risk of blood clots.",
        category: "Erythropoiesis-Stimulating Agents"
    },
    {
        id: "med-kin-4",
        name: "Epoetin alfa",
        genericName: "Brand: Epogen",
        indication: "Anemia in CKD",
        price: "$195",
        originalPrice: "$2,800",
        savings: "93%",
        description: "Epoetin alfa is another erythropoiesis-stimulating agent (ESA) used to treat severe anemia in patients with chronic kidney failure. It acts like the natural hormone erythropoietin.",
        dosage: "Administered as a subcutaneous or intravenous injection.",
        packaging: "Single-dose syringe or vial",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store in a refrigerator at 2°C to 8°C. Do not freeze.",
        sideEffects: "High blood pressure, joint pain, muscle aches, and fever.",
        category: "Erythropoiesis-Stimulating Agents"
    },
    {
        id: "med-kin-5",
        name: "Calcitriol 0.25mcg",
        genericName: "Brand: Rocaltrol",
        indication: "Secondary Hyperparathyroidism",
        price: "$52",
        originalPrice: "$450",
        savings: "88%",
        description: "Calcitriol is the active form of vitamin D. It is used in patients with kidney disease who cannot make enough active vitamin D. It helps regulate calcium and phosphorus levels.",
        dosage: "Taken orally once daily.",
        packaging: "Contains 30 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store below 25°C in a cool, dry place.",
        sideEffects: "High calcium levels, headache, weakness, and dry mouth.",
        category: "Vitamin D Analogs"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-kin-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Kidney disease and renal treatment",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of kidney disease and renal conditions. Sourced from WHO-GMP certified facilities ensuring efficacy and safety.`,
            dosage: "As prescribed by your nephrologist.",
            packaging: "Contains 30 Tablets",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. May include nausea, mild headache, or dizziness.",
            category: "General Renal Care"
        });

        dosageCount += 25; // Increase dosage somewhat
        // Mix up prices slightly
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const nephrologyProducts = [...baseProducts, ...generateAlphabetMeds()];

export const nephrologyHeroData = {
    title: "Kidney Diseases",
    subtitle: "Chronic Kidney disease, dialysis, and renal care medications",
    description: "Access high-quality medications for the management of chronic kidney disease (CKD), complications like anemia, secondary hyperparathyroidism, and general renal care. We ensure global access to affordable, authentic treatments.",
    stats: [
        { number: "35+", label: "Medications" },
        { number: "70%", label: "Average Savings" }
    ]
};

export const nephrologyCategories = [
    "All Categories",
    "Phosphate Binders",
    "Mineral Modifiers",
    "Erythropoiesis-Stimulating Agents",
    "Vitamin D Analogs",
    "Immunosuppressants",
    "General Renal Care"
];

export const nephrologyTrustBadges = [
    { text: "WHO-GMP Certified Sources", icon: "ShieldCheck" },
    { text: "Secure Global Shipping", icon: "Plane" },
    { text: "Verified Pharmacists", icon: "Users" },
    { text: "Quality Guaranteed", icon: "Award" }
];

export const nephrologyFAQs = [
    {
        question: "Do you require a prescription for kidney medications?",
        answer: "Yes, a valid prescription from a licensed nephrologist or physician is required to place an order. You can upload it during checkout or share it securely via WhatsApp."
    },
    {
        question: "How do you maintain the temperature for temperature-sensitive drugs like Aranesp?",
        answer: "We use insulated medical-grade packaging with cold packs to ensure temperature-sensitive medications remain within the required 2°C to 8°C range during transit."
    },
    {
        question: "Are these medications identical to the ones purchased in the US or Europe?",
        answer: "Yes, we source WHO-GMP certified generic equivalents that contain the exact same active pharmaceutical ingredients, ensuring the same efficacy and safety at a fraction of the cost."
    },
    {
        question: "How long does shipping take for chronic care orders?",
        answer: "Standard international shipping typically takes 7-14 business days. Expedited options are available for acute needs."
    }
];

export const nephrologyTestimonials = [
    {
        name: "Michael R.",
        country: "United States",
        savings: "$11,500",
        condition: "CKD Anemia",
        medication: "Darbepoetin alfa",
        text: "Getting my Aranesp equivalent through MediSeller has been life-changing. Not only is the medication perfectly effective, but the savings have rescued my retirement funds. The cold-chain shipping works flawlessly."
    },
    {
        name: "Sarah L.",
        country: "United Kingdom",
        savings: "$8,200",
        condition: "Hyperphosphatemia",
        medication: "Sevelamer",
        text: "The cost of my phosphate binders was becoming unmanageable. Finding this service was a godsend. The quality is identical, and customer support is incredibly responsive and reassuring."
    },
    {
        name: "David T.",
        country: "Australia",
        savings: "$15,000",
        condition: "Secondary Hyperparathyroidism",
        medication: "Cinacalcet",
        text: "Managing kidney disease is stressful enough without the financial burden. The process was simple, the prescription verification was thorough, and the medication arrived exactly as promised."
    }
];

export const nephrologySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Hear from kidney disease patients who saved thousands on their critical medications"
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Everything you need to know about ordering nephrology medications"
    },
    midPageCTA: {
        title: "Can't Find Your Kidney Medication?",
        description: "We have access to 5000+ generic medications. Our specialists can help you source any renal medication from verified Indian manufacturers at up to 80% savings.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Submit Custom Request"
    },
    finalCTA: {
        title: "Ready to Save on Your Treatment?",
        description: "Get expert consultation and authentic kidney disease medications delivered directly to your doorstep.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Request Free Consultation"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
